import React from 'react';
import { Icon } from '../icons';
import { translate } from 'react-i18next';
import styles from './languageswitcher.scss';

const supportedLanguageKeys = process.env.LANGUAGE_SUPPORT.split(',');

const languageNames = {
  en: 'english',
  de: 'deutsch',
  fr: 'français',
  es: 'español',
  'ko-KR': '한국',
  nl: 'nederlands',
  hu: 'magyar',
}

const LanguageSwitcher = ({ i18n }) => {
  return(
      <div className="language-switcher">
        <Icon className="language-switcher-icon" type="world" />
        <select className="language-switcher-select" onChange={(event) => i18n.changeLanguage(event.target.value) } >
          {supportedLanguageKeys.map((lk) => <option key={lk} value={lk}>{languageNames[lk]}</option>)}
        </select>
      </div>
  )
}

// const LanguageSwitcher = ({ i18n }) => {
//   return(
//       <div className="language-switcher">
//         <Icon className="language-switcher-icon" type="world" />
//         <select className="language-switcher-select" onChange={(event) => i18n.changeLanguage(event.target.value) } >
//           <option value="en">english</option>
//           <option value="de">deutsch</option>
//           <option value="fr">français</option>
//           <option value="es">español</option>
//           <option value="ko-KR">한국</option>
//           <option value="nl">nederlands</option>
//         </select>
//       </div>
//   )
// }

export default translate()(LanguageSwitcher);



// WEBPACK FOOTER //
// ./src/components/layout/LanguageSwitcher.js